
export default {
  API_URL: /staging/i.test(document.location.href) ? "https://staging-api.exandria.com" : "https://api.exandria.com"
}
